;(function () {
  'use strict';

  /**
   * jquery.datetimepicker
   */
  var datetimepicker = {
    buildDatePicker: function (targetQuery) {
      var $targets = $(targetQuery || '.js-datepicker');
      if (!$targets.length) {
        return false;
      }

      $targets.datetimepicker({
        format: 'Y-m-d',
        timepicker: false,
        scrollInput: false
      });
    },

    buildDateTimePicker: function (targetQuery) {
      var $targets = $(targetQuery || '.js-datetimepicker');
      if (!$targets.length) {
        return false;
      }

      $targets.datetimepicker({
        format: 'Y-m-d H:i',
        step: 5,
        scrollInput: false,
        minDate: $targets.data('mindate')
      });
    },

    init: function () {
      jQuery.datetimepicker.setLocale('ja');
      this.buildDatePicker();
      this.buildDateTimePicker();
    }
  };

  /**
   * DOM content loaded
   */
  $(function () {
    datetimepicker.init();
  });
}.call(this));
